var exports = {
  "nf": "x31de4314--885329--link",
  "Sl": "x31de4314--885329--image",
  "$0": "x31de4314--885329--title-wrapper",
  "DD": "x31de4314--885329--title",
};

module.exports = exports;
